<template>

  <div>

    <main>
      <div class="container">
        <p>It looks like you’ve reached a page that doesn’t exist. Redirecting you to the assignments page...</p>
      </div>
    </main>

  </div>
</template>

<script>
  export default {
    name: 'page-not-found',
    routeConfig: {
      path: '*'
    },
    metaInfo: {
      title: "Page not Found"
    },
    created () {
      setTimeout(() => {
        this.$router.push({ name: 'assignments' })
      }, 3000)
    }
  }
</script>



// WEBPACK FOOTER //
// src/routes/404/index.vue